import { Tab, TabList, TabPanel, Tabs } from "@mui/joy";
import React from "react";
import ContactsListing from "./ContactsListing";
import ElevatorListing from "./ElevatorListing";
import InspectionReportsListing from "./InspectionReportsListing";
import NotesListing from "./NotesListing";
import TicketListing from "./TicketListing";
import ProposalInvoiceGrid from "./ProposalInvoiceGrid";
import { useRole, isAdminRole } from "../Contexts/RoleContext";

interface BuildingPageProps {
	BuildingID: string;
}

export default function BuildingPage(props: BuildingPageProps) {
	const { effectiveRole } = useRole();
	const isAdmin = isAdminRole(effectiveRole);

	return (
		<Tabs defaultValue="tickets" sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
				<TabList>
					<Tab value="tickets">Tickets</Tab>
					{isAdmin && (
						<>
							<Tab value="elevators">Elevators</Tab>
							<Tab value="notes">Notes</Tab>
							<Tab value="contacts">Contacts</Tab>
							<Tab value="inspection-reports">Inspection Reports</Tab>
						</>
					)}
					<Tab value="estimates">Estimates</Tab>
					<Tab value="invoices">Invoices</Tab>
					{!isAdmin && <Tab value="inspection-reports">Inspection Reports</Tab>}
				</TabList>
				<TabPanel sx={{ p: 2, flex: 1, minHeight: 0, overflow: "auto", "&[hidden]": { display: "none" }, "&:not([hidden])": { display: "flex", flexDirection: "column" } }} value="tickets">
					<TicketListing buildingId={props.BuildingID} />
				</TabPanel>
				{isAdmin && (
					<>
						<TabPanel sx={{ p: 2, flex: 1, minHeight: 0, overflow: "auto", "&[hidden]": { display: "none" } }} value="elevators">
							<ElevatorListing buildingId={props.BuildingID} />
						</TabPanel>
						<TabPanel sx={{ p: 2, flex: 1, minHeight: 0, overflow: "auto", "&[hidden]": { display: "none" } }} value="notes">
							<NotesListing buildingId={props.BuildingID} />
						</TabPanel>
						<TabPanel sx={{ p: 2, flex: 1, minHeight: 0, overflow: "auto", "&[hidden]": { display: "none" } }} value="contacts">
							<ContactsListing buildingId={props.BuildingID} />
						</TabPanel>
					</>
				)}
				<TabPanel sx={{ p: 2, flex: 1, minHeight: 0, overflow: "auto", "&[hidden]": { display: "none" } }} value="inspection-reports">
					<InspectionReportsListing buildingId={props.BuildingID} readOnly={!isAdmin} />
				</TabPanel>
				<TabPanel sx={{ p: 2, flex: 1, minHeight: 0, overflow: "auto", "&[hidden]": { display: "none" } }} value="estimates">
					<ProposalInvoiceGrid buildingId={props.BuildingID} isInvoice={false} />
				</TabPanel>
				<TabPanel sx={{ p: 2, flex: 1, minHeight: 0, overflow: "auto", "&[hidden]": { display: "none" } }} value="invoices">
					<ProposalInvoiceGrid buildingId={props.BuildingID} isInvoice={true} />
				</TabPanel>
		</Tabs>
	);
}
